
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"#5D5D67","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.667 2h-1.111V1a.952.952 0 00-.326-.707A1.177 1.177 0 0014.444 0c-.294 0-.577.105-.785.293a.952.952 0 00-.326.707v1H6.667V1A.952.952 0 006.34.293 1.177 1.177 0 005.556 0c-.295 0-.578.105-.786.293A.952.952 0 004.444 1v1h-1.11c-.885 0-1.733.316-2.358.879C.351 3.44 0 4.204 0 5v12c0 .796.351 1.559.976 2.121.625.563 1.473.879 2.357.879h13.334c.884 0 1.732-.316 2.357-.879.625-.562.976-1.325.976-2.121V5c0-.796-.351-1.559-.976-2.121C18.399 2.316 17.55 2 16.667 2zM3.333 4h1.111v1c0 .265.118.52.326.707.208.188.49.293.786.293.294 0 .577-.105.785-.293A.952.952 0 006.667 5V4h6.666v1c0 .265.117.52.326.707.208.188.49.293.785.293.295 0 .578-.105.786-.293A.952.952 0 0015.556 5V4h1.11c.295 0 .578.105.786.293a.952.952 0 01.326.707v4H2.222V5c0-.265.117-.52.326-.707.208-.188.49-.293.785-.293zm13.334 14H3.333c-.294 0-.577-.105-.785-.293A.952.952 0 012.222 17v-6h15.556v6c0 .265-.117.52-.326.707-.208.188-.49.293-.785.293z"}}),_c('path',{attrs:{"d":"M5.556 15c.614 0 1.112-.448 1.112-1s-.498-1-1.112-1c-.613 0-1.11.448-1.11 1s.497 1 1.11 1zM14.446 13h-4.444c-.295 0-.578.105-.786.293a.952.952 0 00-.325.707c0 .265.117.52.325.707.208.188.491.293.786.293h4.444c.295 0 .578-.105.786-.293a.952.952 0 00.325-.707.952.952 0 00-.325-.707 1.177 1.177 0 00-.786-.293z"}})])
          )
        }
      }
    